
















import VueOptions from '@utils/VueOptions'
import ChartUtility from '@utils/ChartUtility'
import BoxChart from '@ui/Dashboard/Charts/BoxChart'

settings =
  name: 'PurchaseSeriesLineChart'

  vue:
    props: ['data']

    components: {
      BoxChart,
    }

    data: ->
      chart: null
      selectedSerie: 'offers'

    computed:
      dataSerie: ->
        @data?[@selectedSerie]

      noDataAvailable: ->
        @isEmptyValue(@dataSerie)

      total: ->
        total = 0
        for key, value of @dataSerie
          total += value
        total

    methods:
      cleanUp: ->
        @chart?.destroy()

      draw: ->
        data = {}
        shouldGroupByDay = Object.keys(@dataSerie).length < 60

        for date, count of @dataSerie
          if shouldGroupByDay
            if dayjs().year() is dayjs(date).year()
              group = dayjs(date).format('MMM D')
            else
              group = dayjs(date).format('MMM D, YY')
          else if dayjs().year() is dayjs(date).year()
            group = dayjs(date).format('MMM')
          else
            group = dayjs(date).format('MMM, YY')
          data[group] ||= 0
          data[group] += count

        labels = Object.keys(data)

        @chart = new Chart(@$refs.chart, {
          type: 'line'
          data: {
            labels: labels
            datasets: [{
              label: 'Offers'
              data: Object.values(data)
              # tension: 0.4 # chart displays artifacts when using tension
              borderColor: ChartUtility.COLORS.blue
              fill: true
              backgroundColor: (context) =>
                return unless context.chart.chartArea
                gradient = context.chart.ctx.createLinearGradient(0, context.chart.chartArea.top, 0, context.chart.chartArea.bottom)
                gradient.addColorStop(0, 'rgba(52, 144, 220, 0.8)')
                gradient.addColorStop(1, 'rgba(52, 144, 220, 0.3)')
                gradient
            }],
          }
          options: {
            aspectRatio: 1.4
            layout: {
              padding: {
                top: 24
              }
            }
            scales: {
              x: {
                ticks: {
                  maxRotation: 0
                  maxTicksLimit: if shouldGroupByDay then 8 else 18
                  callback: (value, index, ticks) =>
                    text = labels[index]
                }
              }
              y: {
                ticks: {
                  precision: 0
                  callback: (value) =>
                    @$options.filters.formatNumberShort value
                }
              }
            }
            plugins: {
              legend: {
                display: false
              }
              datalabels: {
                borderRadius: 2
                backgroundColor: ChartUtility.COLORS.blue
                color: ChartUtility.COLORS.white
                font: {
                  weight: 'bold'
                }
              }
            }
          }
        })

export default VueOptions.vue settings
